import React, { useEffect } from "react";
import LayoutFrontend from "./include/layout-frontend";
import { useState } from 'react';
import { Link,  useNavigate } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import PublicationsService from "../services/PublicationsService";
import { Button, Image } from "react-bootstrap";
import PeriodiquesService from "../services/PeriodiquesService";
import PanierService from "../services/PanierService";
import Swal from "sweetalert2";
import Header from "./include/header";
import { addToCart } from "../app/providers/panierSlice";
import { useDispatch, useSelector } from "react-redux";
import UsersService from "../services/UsersService";
import axios from "axios";
import { app_url } from "../services/http";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

export default function HomePage(props) {

    const [publications, setPublications] = useState([]);
    const [publication, setPublication] = useState([]);
    const [periodiques, setPeriodiques] = useState([]);  
    const dispatch = useDispatch();
    const {contentPanier} = useSelector(state => state.panier)
    const [nombreUtilisateurs, setNombreUtilisateurs] = useState(0);
    const [nombrePublicationsType1, setNombrePublicationsType1] = useState(0);
    const [nombrePublicationsType2, setNombrePublicationsType2] = useState(0);

    //recherche par titre

    const [searchTerm, setSearchTerm] = useState('');

    const navigate = useNavigate();



    // ajouter panier 

    const ajouterPanier = async (publication) => {
        try {
          let price = publication.montant_publication; // Valeur par défaut
      
          if (publication.typepublication_id === 2 && publication.periodique_id) {
            // Récupérer les informations du périodique
            const periodique = periodiques.find((periodique) => periodique.id === publication.periodique_id);
      
            if (periodique) {
              price = periodique.montant_periodique; // Utiliser montant_periodique pour typepublication_id = 2
            }
          }
      
          let set_publication = {
            id: publication.id,
            name: publication.titre,
            price: price,
            laune: publication.laune_path,
          };
          let item = { ...set_publication, quantity: 1 };
          dispatch(addToCart(item));
          // Voir le contenu du panier
          //console.log(contentPanier);
        } catch (error) {
          console.log(error);
        }
      };
  
   {/**  const addToCart = (itemId) => {
        axios.post('api/cart/store', { itemId })
          .then(response => {
            // Gérer la réponse de l'API
            console.log(response.data);
          })
          .catch(error => {
            // Gérer les erreurs de la requête
            console.error(error);
          });
      }
    */}

      

    useEffect(() => {
        const fetchPublications = async () => {
            try {
              const response = await PublicationsService.index();
              setPublications(response.data.publications); // Utilisez response.data.publications au lieu de response.data
              // Récupérer les libellés des périodiques à partir des IDs
              const ids = response.data.publications.map(publication => publication.periodique_id);
              const periodiquesResponse = await PeriodiquesService.index(ids);
              setPeriodiques(periodiquesResponse.data.liste_periodiques);
              //console.log(periodiquesResponse.data.liste_periodiques)

            } catch (error) {
              console.log(error);
            }
          };
          
        fetchPublications();
      }, []);

      useEffect(() => {
        // Effectuez la requête HTTP en utilisant le service utilisateur
        UsersService.index_users()
          .then(response => {
            if (response.data && response.data.nombre_utilisateurs) {
              const { nombre_utilisateurs } = response.data;
              setNombreUtilisateurs(nombre_utilisateurs);
            } else {
              console.error('Les données de réponse sont incorrectes:', response.data);
            }
          })
          .catch(error => {
            console.error('Erreur lors de la récupération du nombre d\'utilisateurs:', error);
          });
      }, []);
      

      useEffect(() => {
        // Effectuez la requête HTTP en utilisant le service utilisateur
       PublicationsService.index()
          .then(response => {
            const { nombre_publications_type_1, nombre_publications_type_2 } = response.data;
            setNombrePublicationsType1(nombre_publications_type_1);
            setNombrePublicationsType2(nombre_publications_type_2);
          })
          .catch(error => {
            console.error('Erreur lors de la récupération du nombre de publications:', error);
          });
      }, []);

      //Fontion pour prendre le thème de recherche et le renvoyer sur la page de résultats des recherches
      const handleSearch = (e) => {
        e.preventDefault();
        navigate(`/publications/recherche_par_titre/${searchTerm}`)
        window.location.reload();
    };

    return (
        <LayoutFrontend>

           {/* Full Screen Search Start */}
            <div className="modal fade" id="searchModal" tabIndex="-1">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "rgba(9, 30, 62, .7)" }}>
                        <div className="modal-header border-0">
                            <button type="button" className="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body d-flex align-items-center justify-content-center">
                            <div className="input-group" style={{ maxWidth: "600px" }}>
                            <InputGroup className="mb-3">
                                <Form.Control
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="Rechercher par titre"
                                />
                                <Button variant="outline-light" id="button-addon1" onClick={handleSearch}>
                                <i className="bi bi-search"></i>
                                </Button>

                            </InputGroup>
                           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Full Screen Search End */}

            {/* Facts Start */}
            <div className="container-fluid facts py-5 pt-lg-0">
                <div className="container py-5 pt-lg-0">
                    <div className="row gx-0">
                        <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                            <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                                <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-users text-primary"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="text-white mb-0">Utilisateurs</h5>
                                    <h1 className="text-white mb-0" data-toggle="counter-up">{nombreUtilisateurs}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                            <div className="bg-light shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                                <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-book text-white"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="text-primary mb-0">Ouvrages</h5>
                                    <h1 className="mb-0" data-toggle="counter-up">{nombrePublicationsType1}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 wow zoomIn" data-wow-delay="0.6s">
                            <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: "150px" }}>
                                <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: "60px", height: "60px" }}>
                                    <i className="fa fa-book text-primary"></i>
                                </div>
                                <div className="ps-4">
                                    <h5 className="text-white mb-0">Périodiques</h5>
                                    <h1 className="text-white mb-0" data-toggle="counter-up">{nombrePublicationsType2}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Facts Start */}

            {/* Documents Start */}
            <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-3">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" >
                    <h5 className="fw-bold text-primary text-uppercase"></h5>
                    <h1 className="text-legend mb-3 ">OUVRAGES ET PERIODIQUES EN VENTE</h1>
                </div>
                    <div className="row g-5 mt-0">
                    {publications.slice(0,4).map((publication, index) => (
                    <div key={index} className="col-lg-3 wow slideInUp" data-wow-delay="0.3s">
                        <div className="team-item bg-light rounded overflow-hidden">
                        <div className="team-img position-relative overflow-hidden">
                            <Image className="img-fluid w-100" alt="image indisponible" style={{height:"380px"}} src={app_url + "/storage/laune/"+ publication.laune_path} />
                            <div className="team-social">
                            <Link className="btn btn-lg btn-primary btn-lg-square rounded" onClick={()=>ajouterPanier(publication)}><i className="fas fa-shopping-cart"></i></Link>
                            <Link className="btn btn-lg btn-primary btn-lg-square rounded" href="#">
                                <i className="fa fa-heart"></i>
                            </Link>
                            <Link className="btn btn-lg btn-primary btn-lg-square rounded" to={`/details_publications/${publication.id}`}  title="Voir plus d'informations">
                                <i className="fa fa-eye"></i>
                            </Link>
                            <Link className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                                <i className="fa fa-random"></i>
                            </Link>
                            </div>
                        </div>
                        <div className="text-card">
                            {publication.typepublication_id === 2?(
                                <>
                                <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_periodique.substring(0, 25)}...</p>
                                </>
                            ) : (
                                <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_concatene.substring(0, 25)}...</p>
                            )}
                        </div>
                        <div className="text-center py-2" style={{ color: "black", fontWeight: "bold", backgroundColor: "rgb(237, 245, 251)" }}>
                            {publication.typepublication_id === 2 && Array.isArray(periodiques) ? (
                                // Informations spécifiques aux périodiques
                                <p className="text-uppercase m-0">
                                {periodiques.find((periodique) => periodique.id === publication.periodique_id)?.montant_periodique?.toLocaleString() || 'N/A'}{' '}
                                F CFA
                                </p>
                            ) : (
                                // Informations générales des publications
                                <p className="text-uppercase m-0">{publication.montant_publication?.toLocaleString()} F CFA</p>
                            )}
                            </div>

                        </div>
                    </div>
                    ))}

                    <div>
                    
                    </div>
                    </div>
                </div>
            </div>

            {/* Documents End */}

            <div className="m-3 text-center">
            <Link className="button-suite button1-suite" to={myroutes.catalogue}>Voir toutes les publications en vente</Link>
            </div>

            {/* start call action **/}   

            <section id="cta" className="cta mt-5 mb-5">
                        <div className="container">
                            <div className="row" data-aos="zoom-in">
                                <div className="col-lg-8 text-center text-lg-start">
                                    <h3 style={{fontSize:"270%"}}>Vous êtes auteur ou éditeur ! </h3>
                                    <span style={{fontSize:"30px", color:"white"}}> Vous souhaitez nous confier la vente de vos publications sur cette
                                        plateforme ?</span>
                                </div>
                                <div className="col-lg-4 cta-btn-container text-center">
                                    <Link className="cta-btn align-middle" to={myroutes.contact}><strong>Contactez-nous</strong></Link>
                                </div>
                            </div>

                        </div>
                        </section>

                {/* end call action **/} 


                {/* Documents Start */}
                <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container py-3">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" >
                        <h5 className="fw-bold text-primary text-uppercase"></h5>
                        <h1 className="text-legend mb-3 ">OUVRAGES ET PERIODIQUES EN VENTE</h1>
                    </div>
                        <div className="row g-5 mt-0">
                        {publications.slice(0,8).map((publication, index) => (
                        <div key={index} className="col-lg-3 wow slideInUp" data-wow-delay="0.3s">
                            <div className="team-item bg-light rounded overflow-hidden">
                            <div className="team-img position-relative overflow-hidden">
                                <Image className="img-fluid w-100" alt="image indisponible" style={{height:"380px"}} src={app_url + "/storage/laune/" + publication.laune_path} />
                                <div className="team-social">
                                <Link className="btn btn-lg btn-primary btn-lg-square rounded" onClick={()=>ajouterPanier(publication)}><i className="fas fa-shopping-cart"></i></Link>
                                <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                                    <i className="fa fa-heart"></i>
                                </a>
                                <a className="btn btn-lg btn-primary btn-lg-square rounded" href={`/details_publications/${publication.id}`} title="Voir plus d'informations">
                                    <i className="fa fa-eye"></i>
                                </a>
                                <a className="btn btn-lg btn-primary btn-lg-square rounded" href="">
                                    <i className="fa fa-random"></i>
                                </a>
                                </div>
                            </div>
                            <div className="text-card">
                                {publication.typepublication_id === 2?(
                                    <>
                                    <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_periodique.substring(0, 25)}...</p>
                                    </>
                                ) : (
                                    <p className="text-books" style={{ lineHeight: "1.5rem" }}>{publication.titre_concatene.substring(0, 25)}...</p>
                                )}
                            </div>
                                <div className="text-center py-2" style={{ color: "black", fontWeight: "bold" , backgroundColor:"rgb(237, 245, 251)"}}>
                                {publication.typepublication_id === 2 && Array.isArray(periodiques) ? (
                                    // Informations spécifiques aux périodiques
                                    <p className="text-uppercase m-0">      {periodiques.find(p => p.id === publication.periodique_id)?.montant_periodique.toLocaleString()} F CFA
                                    </p>
                                ) : (
                                    // Informations générales des publications
                                    <p className="text-uppercase m-0">{publication.montant_publication?.toLocaleString()} F CFA</p>
                                )}
                                </div>
                            </div>
                        </div>
                        ))}

                        <div>
                        
                        </div>
                        </div>
                    </div>
                </div>

                {/* Documents End */}

                <div className="m-3 text-center">
                <Link className="button-suite button1-suite" to={myroutes.catalogue}>Voir toutes les publications en vente</Link>
                </div>


        </LayoutFrontend>
    )
}